import { ReactNode } from 'react';
import { useDarkMode } from '../context/DarkModeContext';
import LoginBrandPanel from './layouts/LoginBrandPanel';

interface RedirectLoaderScreenProps {
  children: ReactNode;
}

/** Full-screen shell for `RedirectLoader`, matching `LoginLayout`'s split layout (and the
 * same breakpoints) so the redirect loading state feels continuous with the login page. */
function RedirectLoaderScreen({ children }: RedirectLoaderScreenProps) {
  const { isDarkMode, colors: dm } = useDarkMode();

  return (
    <div className="flex h-screen w-screen overflow-hidden">
      <LoginBrandPanel className="flex-[5]" />
      <div
        className="flex flex-col items-center justify-center gap-4 flex-[7] p-6 overflow-y-auto"
        style={{ background: isDarkMode ? dm?.BG : '#f9fafb' }}
      >
        {children}
      </div>
    </div>
  );
}

export default RedirectLoaderScreen;
